"use client";

import Image from "next/image";

export default function AuthBrandingPanel({
  onLogoClick,
}: {
  onLogoClick: () => void;
}) {
  return (
    <div className="relative hidden overflow-hidden bg-slate-900 lg:flex lg:w-1/2">
      <div className="absolute inset-0 z-0">
        <Image
          src="/images/topografo.jpg"
          alt="Profissional de topografia em campo"
          fill
          priority
          sizes="50vw"
          className="object-cover opacity-50 mix-blend-overlay"
        />
      </div>
      <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-br from-primary/30 via-slate-900/80 to-slate-900" />

      <div className="relative z-20 flex w-full flex-col justify-between p-12">
        <button
          type="button"
          className="flex cursor-pointer items-center gap-3 text-left"
          onClick={onLogoClick}
        >
          <span className="flex size-10 items-center justify-center rounded bg-primary p-2">
            <Image
              src="/logo-platform-white.svg"
              alt="GeoOffice Platform"
              width={24}
              height={24}
              className="size-6"
            />
          </span>
          <span className="text-2xl font-bold tracking-tight text-white uppercase">
            GeoOffice <span className="text-primary">Platform</span>
          </span>
        </button>

        <div>
          <h1 className="mb-6 text-5xl leading-tight font-extrabold text-white">
            O futuro da <br />
            <span className="text-primary">Engenharia Digital.</span>
          </h1>
          <p className="max-w-md text-lg text-slate-300">
            Junte-se a milhares de profissionais e transforme seus levantamentos
            em resultados extraordinários.
          </p>
        </div>

        <div className="flex items-center gap-4 font-mono text-xs tracking-widest text-slate-500 uppercase">
          <span>REGISTER_NEW_NODE</span>
          <span className="size-1 animate-pulse rounded-full bg-primary" />
          <span>UPLINK: WAITING</span>
        </div>
      </div>
    </div>
  );
}
